import { render, staticRenderFns } from "./public-models.html?vue&type=template&id=61d44638&scoped=true&external"
import script from "./public-models.js?vue&type=script&lang=js&external"
export * from "./public-models.js?vue&type=script&lang=js&external"
import style0 from "./public-models.scss?vue&type=style&index=0&id=61d44638&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d44638",
  null
  
)

export default component.exports